import * as Sentry from '@sentry/react';

interface UseDownloadFromSignedURLOptions {
  getSignedURL: () => Promise<string>;
  filename: string;
  setLoading: (loading: boolean) => void;
  onSuccess?: () => void | Promise<void>;
  onError?: (error: unknown) => void;
}

export const useDownloadFromSignedURL = ({
  getSignedURL,
  filename,
  setLoading,
  onSuccess,
  onError,
}: UseDownloadFromSignedURLOptions): (() => Promise<void>) => {
  const download = async (): Promise<void> => {
    try {
      setLoading(true);
      const signedURL = await getSignedURL();
      const response = await fetch(signedURL);
      const blob = await response.blob();
      const downloadURL = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = downloadURL;
      anchor.download = filename;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(downloadURL);
      await onSuccess?.();
    } catch (error) {
      Sentry.captureException(error);
      onError?.(error);
    } finally {
      setLoading(false);
    }
  };

  return download;
};
